<template>
  <CreateEditDistributionModal
    v-if="showCreateEditDistributionModal"
    :distributionSetupId="distributionSetupIdSelected"
    @closeModal="closeModal"
  />
  <RunDistributionModal
    v-if="showRunDistributionModal"
    :distributionSetupId="distributionSetupIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Distribuições</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Gerencie as configurações de distribuição das pesquisas
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Cadastrar Distribuição"
          @click="createEditDistribution()"
        >
          Cadastrar Distribuição
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListDistributionSetups
      v-else
      :distributionSetups="distributionSetups"
      @createEditDistribution="createEditDistribution"
      @runDistribution="runDistribution"
    />
  </div>
</template>

<script>
import CreateEditDistributionModal from '@/components/params/distributions/CreateEditDistributionModal.vue'
import RunDistributionModal from '@/components/params/distributions/RunDistributionModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListDistributionSetups from '@/components/params/distributions/ListDistributionSetups.vue'

export default {
  name: 'Distributions',

  components: {
    CreateEditDistributionModal,
    RunDistributionModal,
    LoadingData,
    ListDistributionSetups,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditDistributionModal: false,
      showRunDistributionModal: false,
      distributionSetups: [],
      distributionSetupIdSelected: null,
    }
  },

  methods: {
    async getDistributionsSetup() {
      try {
        this.distributionSetups = await this.$store.dispatch(
          'getDistributionsSetup',
        )
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditDistribution(distributionSetupId) {
      this.distributionSetupIdSelected = distributionSetupId || null
      this.showCreateEditDistributionModal = true
    },

    runDistribution(distributionSetupId) {
      this.distributionSetupIdSelected = distributionSetupId
      this.showRunDistributionModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getDistributionsSetup()
      }
      this.showCreateEditDistributionModal = false
      this.showRunDistributionModal = false
    },
  },

  mounted() {
    this.getDistributionsSetup()
  },
}
</script>
